import React, { Component } from "react";
import { Row, Spinner, Col } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import gql from "graphql-tag";
import { withRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { components } from 'react-select';
import SelectDropDown from '../selectdropdown/SelectDropDown';

// ── Material-inspired design tokens ─────────────────────────────────────────────
const T = {
    primary: "#6366f1",
    primaryDark: "#4f46e5",
    primarySoft: "#eef2ff",
    primaryBorder: "#c7d2fe",
    text: "#111827",
    textMuted: "#6b7280",
    line: "#e5e7eb",
    lineSoft: "#f1f5f9",
    surface: "#ffffff",
    surfaceAlt: "#f8fafc",
    danger: "#dc2626",
    dangerSoft: "#fef2f2",
    success: "#059669",
};

const S = {
    page: {
        minHeight: "100vh",
        padding: "24px",
        background: "linear-gradient(180deg, #f5f7ff 0%, #f8fafc 100%)",
    },

    // ── Card shell (Material elevation) ──
    card: {
        background: T.surface,
        borderRadius: 16,
        boxShadow: "0 1px 2px rgba(16,24,40,0.06), 0 8px 24px -12px rgba(16,24,40,0.10)",
        border: "1px solid " + T.lineSoft,
        marginBottom: 20,
        overflow: "hidden",
    },
    // Same shell but lets child dropdowns (Class / Stream MultiSelect) overflow the card
    // instead of being clipped, and stacks above the grid card below it.
    filterCard: {
        background: T.surface,
        borderRadius: 16,
        boxShadow: "0 1px 2px rgba(16,24,40,0.06), 0 8px 24px -12px rgba(16,24,40,0.10)",
        border: "1px solid " + T.lineSoft,
        marginBottom: 20,
        overflow: "visible",
        position: "relative",
        zIndex: 20,
    },

    // ── Page header ──
    headerBar: {
        display: "flex",
        alignItems: "center",
        gap: 14,
        padding: "20px 24px",
        background: "linear-gradient(120deg, #6366f1 0%, #8b5cf6 100%)",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
    },
    headerIcon: {
        width: 46,
        height: 46,
        borderRadius: 12,
        background: "rgba(255,255,255,0.18)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: 20,
        flexShrink: 0,
        backdropFilter: "blur(6px)",
    },
    headerTitle: { color: "#fff", fontWeight: 700, fontSize: 18, margin: 0, letterSpacing: "-0.01em" },
    headerSub: { color: "rgba(255,255,255,0.82)", fontSize: 12.5, marginTop: 2 },

    // ── Filter section ──
    sectionLabel: {
        display: "flex", alignItems: "center", gap: 8,
        fontSize: 13, fontWeight: 700, color: T.text,
        padding: "16px 24px 4px",
    },
    filterGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: 16,
        padding: "8px 24px 22px",
    },
    field: { display: "flex", flexDirection: "column", minWidth: 0 },
    label: {
        fontSize: 11,
        fontWeight: 700,
        color: T.textMuted,
        marginBottom: 7,
        textTransform: "uppercase",
        letterSpacing: "0.6px",
        display: "flex",
        alignItems: "center",
        gap: 6,
    },
    labelIcon: { color: T.primary, fontSize: 12 },
    streamHint: {
        fontSize: 11,
        color: T.primary,
        marginTop: 6,
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        fontWeight: 600,
    },

    // ── Data grid ──
    gridHeaderRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 12,
        padding: "16px 24px",
        borderBottom: "1px solid " + T.lineSoft,
    },
    gridTitle: { display: "flex", alignItems: "center", gap: 10 },
    gridTitleIcon: {
        width: 34, height: 34, borderRadius: 9, background: T.primarySoft,
        color: T.primary, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14,
    },
    gridTitleText: { fontSize: 15, fontWeight: 700, color: T.text },
    gridTitleSub: { fontSize: 12, color: T.textMuted, marginTop: 1 },

    searchWrap: { position: "relative", minWidth: 240, flex: "0 1 300px" },
    searchInput: {
        width: "100%",
        padding: "9px 14px 9px 38px",
        fontSize: 13.5,
        borderRadius: 10,
        border: "1.5px solid " + T.line,
        outline: "none",
        background: T.surfaceAlt,
        transition: "border-color .15s, box-shadow .15s, background .15s",
    },
    searchIcon: { position: "absolute", left: 13, top: "50%", transform: "translateY(-50%)", color: "#9ca3af", fontSize: 13 },
    clearSearch: {
        position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)",
        background: "none", border: "none", color: "#9ca3af", cursor: "pointer", fontSize: 13, padding: 4,
    },

    tableScroll: { overflowX: "auto", padding: "4px 0" },
    table: { width: "100%", borderCollapse: "separate", borderSpacing: 0, minWidth: 720 },
    th: {
        padding: "12px 18px",
        fontSize: 11,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        color: T.textMuted,
        textAlign: "left",
        background: T.surfaceAlt,
        borderBottom: "1px solid " + T.line,
        whiteSpace: "nowrap",
        position: "sticky",
        top: 0,
    },
    thSubjects: { minWidth: 340 },
    td: {
        padding: "14px 18px",
        fontSize: 13.5,
        color: T.text,
        borderBottom: "1px solid " + T.lineSoft,
        verticalAlign: "middle",
    },
    sno: {
        width: 26, height: 26, borderRadius: "50%", background: T.primarySoft, color: T.primaryDark,
        display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700,
    },
    classPill: {
        display: "inline-block", padding: "3px 12px", borderRadius: 8,
        background: "#eff6ff", color: "#1d4ed8", fontWeight: 700, fontSize: 13,
    },
    streamBadge: {
        display: "inline-flex", alignItems: "center", gap: 6, padding: "3px 11px", borderRadius: 999,
        background: "#f5f3ff", color: "#7c3aed", fontWeight: 600, fontSize: 12, border: "1px solid #e9d5ff",
    },
    streamDash: { color: "#cbd5e1", fontWeight: 600 },

    chipRow: { display: "flex", flexWrap: "wrap", gap: 8 },
    rowError: { fontSize: 11.5, color: T.danger, fontWeight: 600, marginTop: 8, display: "flex", alignItems: "center", gap: 5 },
    subjCount: { fontSize: 11, color: T.textMuted, fontWeight: 600, marginBottom: 8 },

    // ── Empty / loading ──
    empty: { textAlign: "center", padding: "56px 20px", color: "#9ca3af" },
    emptyIcon: { fontSize: 44, marginBottom: 12, display: "block", color: T.primaryBorder },
    emptyText: { fontWeight: 700, fontSize: 15, color: T.textMuted, margin: 0 },
    emptySub: { fontSize: 13, color: "#9ca3af", marginTop: 4 },

    // ── Pagination ──
    pagination: {
        display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 14,
        padding: "14px 24px", borderTop: "1px solid " + T.lineSoft, background: T.surfaceAlt,
    },
    pageSizeSelect: {
        padding: "7px 12px", borderRadius: 8, border: "1.5px solid " + T.line, background: "#fff",
        color: T.text, outline: "none", cursor: "pointer", fontWeight: 600, fontSize: 13,
    },
    pageInfo: { fontSize: 13, color: T.textMuted },
    pageBtns: { display: "flex", alignItems: "center", gap: 6 },
    pageBtn: {
        minWidth: 34, height: 34, padding: "0 10px", fontSize: 13, fontWeight: 600, borderRadius: 8,
        border: "1.5px solid " + T.line, background: "#fff", color: "#4b5563", cursor: "pointer",
        display: "flex", alignItems: "center", justifyContent: "center", transition: "all .15s",
    },
    pageBtnActive: { background: T.primary, color: "#fff", borderColor: T.primary },
    pageBtnDisabled: { background: "#f3f4f6", color: "#d1d5db", borderColor: T.line, cursor: "not-allowed" },

    // ── Save bar ──
    saveBar: { display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 14, marginTop: 4 },
    btnSave: {
        display: "inline-flex", alignItems: "center", gap: 8,
        background: "linear-gradient(120deg, #10b981 0%, #059669 100%)",
        border: "none", borderRadius: 10, padding: "11px 26px", fontWeight: 700, fontSize: 14, color: "#fff",
        cursor: "pointer", boxShadow: "0 6px 16px -6px rgba(16,185,129,0.5)",
    },
};

const ADD_CLASS_SUBJECTS = gql`
    mutation addClassSubjects($data: [ClassSubjects!]) {
        addClassSubjects(data: $data)
    }
`;

const GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR = gql`
    query getClassSubjectsByAcademicYear(
        $academic_year_id: Int!
        $exam_standard_ids: String
        $classIds: String
        $stream_ids: String
        $institute_id: Int!
    ) {
        getClassSubjectsByAcademicYear(
            academic_year_id: $academic_year_id
            exam_standard_ids: $exam_standard_ids
            classIds: $classIds
            stream_ids: $stream_ids
            institute_id: $institute_id
        ) {
            id
            class_id
            class_name
            checked
            class_name
            stream_id
            stream_name
            subject_ids
            subject_names
        }
    }
`;

// Soft, distinct tag colors — each subject gets a stable color derived from its name so
// "Physics" is always blue, "Chemistry" always green, etc. (like the reference design).
const SUBJECT_PALETTE = [
    { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" }, // blue
    { bg: "#ecfdf5", text: "#047857", border: "#a7f3d0" }, // green
    { bg: "#fff7ed", text: "#c2410c", border: "#fed7aa" }, // orange
    { bg: "#faf5ff", text: "#7c3aed", border: "#e9d5ff" }, // purple
    { bg: "#fef2f2", text: "#b91c1c", border: "#fecaca" }, // red
    { bg: "#ecfeff", text: "#0e7490", border: "#a5f3fc" }, // cyan
    { bg: "#fdf4ff", text: "#a21caf", border: "#f5d0fe" }, // fuchsia
    { bg: "#f7fee7", text: "#4d7c0f", border: "#d9f99d" }, // lime
    { bg: "#fffbeb", text: "#b45309", border: "#fde68a" }, // amber
    { bg: "#eef2ff", text: "#4338ca", border: "#c7d2fe" }, // indigo
];

const getSubjectColor = (name = "") => {
    let hash = 0;
    const key = String(name);
    for (let i = 0; i < key.length; i++) {
        hash = (hash * 31 + key.charCodeAt(i)) | 0;
    }
    return SUBJECT_PALETTE[Math.abs(hash) % SUBJECT_PALETTE.length];
};

const parseCsv = (value = "") =>
    String(value)
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);

const isCheckedValue = (value) => {
    if (value === true || value === 1) return true;
    const normalized = String(value ?? "").trim().toLowerCase();
    return normalized === "true" || normalized === "1";
};

const parseRowSubjects = (row) => {
    const ids = parseCsv(row.subject_ids);
    const names = parseCsv(row.subject_names);
    const checkedValues = parseCsv(row.checked);
    return ids.map((id, index) => ({
        id: String(id),
        name: names[index] || id,
        checked: checkedValues.length ? isCheckedValue(checkedValues[index]) : false,
    }));
};

class CreateClassSubjects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAcademicYear: "",
            selectedExamBoard: "",
            selectedClasses: [],
            selectedStreams: [],
            loader: 0,
            classSubjects: [],
            subjectSelections: {},
            rowErrors: {},
            isSubmitting: false,
            searchQuery: "",
            currentPage: 1,
            pageSize: 10,
        };
    }

    componentDidMount() {
        const firstYear = this.props.getYears?.[0];
        if (firstYear) {
            this.setState({ selectedAcademicYear: String(firstYear.id) });
        }
    }

    getSelectedYearLabel = () => {
        const year = this.props.getYears?.find(
            (item) => String(item.id) === String(this.state.selectedAcademicYear)
        );
        return year?.academic_year || "—";
    };

    getSelectedExamBoardLabel = () => {
        const board = this.props.getExamBoards?.find(
            (item) => String(item.board_id) === String(this.state.selectedExamBoard)
        );
        return board?.exam_board_name || "—";
    };

    sortClassesByName = (classes) =>
        [...(classes || [])].sort((a, b) =>
            String(a.value ?? "").localeCompare(
                String(b.value ?? ""),
                undefined,
                { sensitivity: "base", numeric: true }
            )
        );

    handleClassChange = (selected) => {
        this.setState(
            {
                selectedClasses: selected,
                selectedStreams: [],
                classSubjects: [],
                subjectSelections: {},
                rowErrors: {},
                searchQuery: "",
                currentPage: 1,
            },
            () => {
                // Auto-select all available streams (e.g. for 11/12); user can deselect after
                const allStreams = this.getStreamOptions();
                this.setState({ selectedStreams: allStreams }, () => {
                    if (selected.length && this.state.selectedAcademicYear) {
                        this.handleFetchData();
                    }
                });
            }
        );
    };

    handleStreamChange = (selected) => {
        this.setState({ selectedStreams: selected }, () => {
            if (this.state.selectedClasses.length && this.state.selectedAcademicYear) {
                this.handleFetchData();
            }
        });
    };

    // Streams are mapped to specific classes in the master data — only Classes 11 & 12
    // carry streams — so this returns options ONLY when a stream-bearing class is selected.
    // That's what keeps the Stream dropdown hidden for every other class.
    getStreamOptions = () => {
        const { getStreams } = this.props;
        const { selectedClasses } = this.state;
        if (!getStreams?.length || !selectedClasses.length) return [];
        const selectedClassIds = selectedClasses.map((c) => Number(c.value));
        return (getStreams || [])
            .filter((st) => {
                const classCsv = String(st.classes || "").split(",").map((v) => Number(v.trim())).filter(Boolean);
                return classCsv.some((cid) => selectedClassIds.includes(cid));
            })
            .map((st) => ({ value: st.id, label: st.stream }));
    };

    // A class can appear once per selected stream (e.g. 11-MPC and 11-BiPC are two rows).
    // Subject selections and row errors are keyed by this class+stream pair so each
    // class-stream combination is independent and is saved as its OWN object.
    getRowKey = (row) => {
        const streamPart = row.stream_id != null && row.stream_id !== "" ? row.stream_id : "";
        return `${row.class_id}__${streamPart}`;
    };

    buildSubjectSelections = (rows = []) => {
        const subjectSelections = {};
        rows.forEach((row) => {
            const checkedSubjects = parseRowSubjects(row).filter((subject) => subject.checked);
            subjectSelections[this.getRowKey(row)] = new Set(
                checkedSubjects.map((subject) => subject.id)
            );
        });
        return subjectSelections;
    };

    getAllSubjects = (rows = []) => {
        const subjectMap = new Map();
        rows.forEach((row) => {
            parseRowSubjects(row).forEach((subject) => {
                if (!subjectMap.has(subject.id)) {
                    subjectMap.set(subject.id, subject.name);
                }
            });
        });
        return Array.from(subjectMap.entries()).map(([id, name]) => ({ id, name }));
    };

    handleFormChange = (e) => {
        const { name, value } = e.target;
        const updates = { [name]: value };

        if (name === "selectedAcademicYear") {
            updates.selectedExamBoard = "";
            updates.selectedClasses = [];
            updates.selectedStreams = [];
            updates.searchQuery = "";
            updates.currentPage = 1;
        } else if (name === "selectedExamBoard") {
            updates.selectedClasses = [];
            updates.selectedStreams = [];
            updates.searchQuery = "";
            updates.currentPage = 1;
        }

        this.setState(updates, () => {
            if (name === "selectedAcademicYear" && value) {
                this.handleFetchData();
            } else if (name === "selectedExamBoard") {
                const { selectedClasses, selectedAcademicYear } = this.state;
                if (selectedClasses.length && selectedAcademicYear) {
                    this.handleFetchData();
                }
            }
        });
    };

    handleSelectChange = (name, value) => {
        const updates = { [name]: String(value) };
        if (name === "selectedAcademicYear") {
            updates.selectedExamBoard = "";
            updates.selectedClasses = [];
            updates.selectedStreams = [];
            updates.searchQuery = "";
            updates.currentPage = 1;
        } else if (name === "selectedExamBoard") {
            updates.selectedClasses = [];
            updates.selectedStreams = [];
            updates.searchQuery = "";
            updates.currentPage = 1;
        }
        this.setState(updates, () => {
            if (name === "selectedAcademicYear" && value) {
                this.handleFetchData();
            } else if (name === "selectedExamBoard") {
                const { selectedClasses, selectedAcademicYear } = this.state;
                if (selectedClasses.length && selectedAcademicYear) {
                    this.handleFetchData();
                }
            }
        });
    };

    handleSubjectToggle = (rowKey, subjectId) => {
        this.setState((prevState) => {
            const current = new Set(prevState.subjectSelections[rowKey] || []);
            if (current.has(subjectId)) {
                current.delete(subjectId);
            } else {
                current.add(subjectId);
            }
            const rowErrors = { ...prevState.rowErrors };
            if (current.size > 0) {
                delete rowErrors[rowKey];
            }
            return {
                subjectSelections: {
                    ...prevState.subjectSelections,
                    [rowKey]: current,
                },
                rowErrors,
            };
        });
    };

    buildSavePayload = () => {
        const {
            classSubjects,
            subjectSelections,
            selectedAcademicYear,
            selectedExamBoard,
        } = this.state;

        const instituteId = parseInt(Cookies.get("institutionid"), 10);
        const insertedBy = parseInt(Cookies.get("id"), 10);
        const academicYearId = parseInt(selectedAcademicYear, 10);
        const examStandardId = parseInt(selectedExamBoard, 10);

        // Selected stream ids that apply to a given class. The Stream dropdown holds the
        // chosen streams; each stream master row (getStreams) lists the class ids it applies
        // to via its `classes` CSV. Used to fill stream_id when the API row doesn't carry one.
        const streamMaster = this.props.getStreams || [];
        const selectedStreamIds = (this.state.selectedStreams || []).map((s) => s.value);
        const applicableStreamIds = (classId) =>
            streamMaster
                .filter((st) => {
                    if (!selectedStreamIds.some((sid) => String(sid) === String(st.id))) return false;
                    const classCsv = String(st.classes || "").split(",").map((v) => Number(v.trim())).filter(Boolean);
                    return classCsv.includes(Number(classId));
                })
                .map((st) => st.id);

        // One object per class-stream combination the user actually mapped. Only rows with at
        // least one selected subject are sent. When the API row has no stream_id, we fall back
        // to the SELECTED stream(s) for that class — one object per applicable stream.
        const out = [];
        classSubjects
            .filter((row) => (subjectSelections[this.getRowKey(row)] || new Set()).size > 0)
            .forEach((row) => {
                const subjectIds = Array.from(subjectSelections[this.getRowKey(row)] || []).join(",");
                const base = {
                    institute_id: instituteId,
                    academic_year_id: academicYearId,
                    exam_standard_id: examStandardId,
                    class_id: parseInt(row.class_id, 10),
                    subject_ids: subjectIds,
                    inserted_by: insertedBy,
                };

                // Which stream(s) does this saved object carry?
                //   - API row already has a stream  -> use it
                //   - else the selected streams for this class (may be several)
                //   - else no stream at all (null)
                let streamIds;
                if (row.stream_id != null && row.stream_id !== "") {
                    streamIds = [parseInt(row.stream_id, 10)];
                } else {
                    const applicable = applicableStreamIds(row.class_id);
                    streamIds = applicable.length ? applicable.map((sid) => parseInt(sid, 10)) : [null];
                }

                const parsedId = parseInt(row.id, 10);
                const hasId = row.id != null && row.id !== "" && !Number.isNaN(parsedId);

                streamIds.forEach((streamId) => {
                    const entry = { ...base, stream_id: streamId };
                    // Keep the existing row's id ONLY when it maps to a single object (update).
                    // A row expanded across multiple streams becomes multiple inserts (no id),
                    // so the same id isn't reused for different stream records.
                    if (hasId && streamIds.length === 1) {
                        entry.id = parsedId;
                    }
                    out.push(entry);
                });
            });
        return out;
    };

    handleSubmit = async () => {
        const {
            classSubjects,
            selectedAcademicYear,
            selectedExamBoard,
            isSubmitting,
        } = this.state;

        if (isSubmitting) return;

        if (!selectedAcademicYear) {
            toast.error("Please select academic year");
            return;
        }

        if (!selectedExamBoard) {
            toast.error("Please select exam standard");
            return;
        }

        if (!classSubjects.length) {
            toast.error("No class subjects to save");
            return;
        }

        // Only the class-stream rows the user mapped subjects to are saved. Empty stream
        // rows are left untouched (not required), so we just need ONE mapped row overall.
        const payload = this.buildSavePayload();
        if (!payload.length) {
            toast.error("Add subjects to at least one class / stream before saving");
            return;
        }

        this.setState({ rowErrors: {}, isSubmitting: true });
        try {
            const res = await this.props.addClassSubjects({
                variables: { data: payload },
            });

            if (res?.data?.addClassSubjects) {
                toast.success("Class subjects saved successfully");
                await this.handleFetchData();
            } else {
                toast.error("Could not save class subjects");
            }
        } catch (err) {
            console.error(err);
            toast.error(err?.message || "Failed to save class subjects");
        } finally {
            this.setState({ isSubmitting: false });
        }
    };

    // The backend returns one row per class (a single stream, or none). Expand it so there's
    // a row for every SELECTED stream that applies to the class. Each stream row reuses the
    // class's subject list + selection base; a stream that the API DID return keeps its own
    // id (update) — synthesized stream rows have no id (insert). Non-stream classes are left
    // as-is (a single row with no stream).
    expandRowsBySelectedStreams = (apiData = []) => {
        const streamMaster = this.props.getStreams || [];
        const selectedStreams = this.state.selectedStreams || [];
        const selectedStreamIds = selectedStreams.map((s) => String(s.value));
        const streamLabelById = {};
        selectedStreams.forEach((s) => { streamLabelById[String(s.value)] = s.label; });

        // Selected streams that apply to a class (via each stream's `classes` CSV).
        const applicableStreamIds = (classId) =>
            streamMaster
                .filter((st) => {
                    if (!selectedStreamIds.includes(String(st.id))) return false;
                    const classCsv = String(st.classes || "").split(",").map((v) => Number(v.trim())).filter(Boolean);
                    return classCsv.includes(Number(classId));
                })
                .map((st) => String(st.id));

        // One base row per class (the subject list + checked defaults come from here).
        const baseByClass = {};
        apiData.forEach((row) => {
            if (!baseByClass[row.class_id]) baseByClass[row.class_id] = row;
        });

        const out = [];
        Object.keys(baseByClass).forEach((classId) => {
            const base = baseByClass[classId];
            const streamIds = applicableStreamIds(classId);

            if (!streamIds.length) {
                out.push(base); // non-stream class — keep the single row
                return;
            }

            streamIds.forEach((sid) => {
                // If the API already returned this exact class+stream, keep its own id/checked.
                const existing = apiData.find(
                    (r) => String(r.class_id) === String(classId) && String(r.stream_id) === String(sid)
                );
                const src = existing || base;
                out.push({
                    ...src,
                    id: existing ? existing.id : null,
                    class_id: classId,
                    class_name: base.class_name,
                    stream_id: sid,
                    stream_name: streamLabelById[String(sid)] || (existing ? existing.stream_name : ""),
                    // same subject list + selection base for every stream of the class
                    subject_ids: base.subject_ids,
                    subject_names: base.subject_names,
                    checked: existing ? existing.checked : base.checked,
                });
            });
        });
        return out;
    };

    handleFetchData = async () => {
        const { selectedAcademicYear, selectedExamBoard, selectedClasses, selectedStreams } = this.state;
        if (!selectedAcademicYear) return;

        if (!selectedClasses.length) {
            this.setState({
                loader: 0,
                classSubjects: [],
                subjectSelections: {},
                rowErrors: {},
                currentPage: 1,
            });
            return;
        }

        this.setState({ loader: 1 });
        try {
            const res = await this.props.client.query({
                query: GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR,
                variables: {
                    academic_year_id: parseInt(selectedAcademicYear, 10),
                    exam_standard_ids: selectedExamBoard ? String(selectedExamBoard) : null,
                    classIds: selectedClasses.map((item) => item.value).join(","),
                    stream_ids: selectedStreams.length ? selectedStreams.map((item) => item.value).join(",") : null,
                    institute_id: parseInt(Cookies.get("institutionid"), 10),
                },
                fetchPolicy: "no-cache",
            });

            const apiData = res?.data?.getClassSubjectsByAcademicYear || [];
            // Backend returns a single row per class even when several streams are selected.
            // Fan it out into one row per SELECTED stream (same subject list / selection base)
            // so every chosen stream shows in the grid and is saved with its own stream_id.
            const expanded = this.expandRowsBySelectedStreams(apiData);
            this.setState({
                classSubjects: expanded,
                subjectSelections: this.buildSubjectSelections(expanded),
                rowErrors: {},
                currentPage: 1,
            });
        } catch (err) {
            console.error(err);
            toast.error("Failed to fetch class subjects");
            this.setState({ classSubjects: [], subjectSelections: {}, rowErrors: {}, currentPage: 1 });
        } finally {
            this.setState({ loader: 0 });
        }
    };

    // Stream cell — shows the stream name (Classes 11 & 12), or a dash for classes with no stream.
    renderStreamCell = (row) => {
        if (row.stream_id && row.stream_name) {
            return (
                <span style={S.streamBadge}>
                    <i className="fa fa-sitemap" style={{ fontSize: 10 }} />
                    {row.stream_name}
                </span>
            );
        }
        return <span style={S.streamDash}>—</span>;
    };

    // Subjects cell — one toggleable chip per available subject. Filled = mapped to the
    // class-stream row. Keyed by getRowKey so a class's two stream rows stay independent.
    renderSubjectsCell = (row) => {
        const rowKey = this.getRowKey(row);
        const selectedSet = this.state.subjectSelections[rowKey] || new Set();
        const subjects = parseRowSubjects(row);
        const rowError = this.state.rowErrors[rowKey];

        if (!subjects.length) {
            return <span style={{ color: "#9ca3af", fontSize: 12.5 }}>No subjects available</span>;
        }

        return (
            <div>
                <div style={S.subjCount}>{selectedSet.size} of {subjects.length} selected</div>
                <div style={S.chipRow}>
                    {subjects.map((subject) => {
                        const isSel = selectedSet.has(subject.id);
                        // Selected -> the subject's own colored tag; unselected -> muted outline.
                        const c = getSubjectColor(subject.name);
                        const chipStyle = isSel
                            ? { background: c.bg, color: c.text, border: `1.5px solid ${c.border}` }
                            : undefined;
                        return (
                            <button
                                key={`${rowKey}-${subject.id}`}
                                type="button"
                                className="csm-chip"
                                style={chipStyle}
                                onClick={() => this.handleSubjectToggle(rowKey, subject.id)}
                            >
                                <i className={`fa ${isSel ? "fa-check-circle" : "fa-circle-o"}`} style={{ fontSize: 12 }} />
                                {subject.name}
                            </button>
                        );
                    })}
                </div>
                {rowError && (
                    <div style={S.rowError}>
                        <i className="fa fa-exclamation-circle" style={{ fontSize: 12 }} />
                        {rowError}
                    </div>
                )}
            </div>
        );
    };

    renderTable = () => {
        const { classSubjects, loader, rowErrors, selectedClasses, searchQuery, currentPage, pageSize } = this.state;
        const yearLabel = this.getSelectedYearLabel();
        const examLabel = this.getSelectedExamBoardLabel();

        if (loader && !classSubjects.length) {
            return (
                <div style={{ padding: "24px" }}>
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="csm-shimmer" style={{ width: i % 3 === 0 ? "78%" : "100%" }} />
                    ))}
                </div>
            );
        }

        if (!classSubjects.length) {
            if (!selectedClasses.length) {
                return (
                    <div style={S.empty}>
                        <span style={S.emptyIcon}><i className="fa fa-hand-pointer-o" /></span>
                        <p style={S.emptyText}>Select the filters above to begin</p>
                        <div style={S.emptySub}>Pick an academic year, exam standard and class to map subjects.</div>
                    </div>
                );
            }
            return (
                <div style={S.empty}>
                    <span style={S.emptyIcon}><i className="fa fa-book" /></span>
                    <p style={S.emptyText}>No class subjects found</p>
                    <div style={S.emptySub}>Try a different class or stream selection.</div>
                </div>
            );
        }

        // Sort + search filter
        const query = searchQuery.trim().toLowerCase();
        const sortedClassSubjects = this.sortClassesByName(
            (classSubjects || []).map((row) => ({ ...row, value: row.class_id }))
        );
        const filteredSubjects = sortedClassSubjects.filter((row) => {
            if (!query) return true;
            const classNameMatch = (row.class_name || "").toLowerCase().includes(query);
            const streamMatch = (row.stream_name || "").toLowerCase().includes(query);
            const subjectNamesMatch = (row.subject_names || "").toLowerCase().includes(query);
            return classNameMatch || streamMatch || subjectNamesMatch;
        });

        // Pagination
        const pageSizeNum = pageSize === "All" ? filteredSubjects.length || 1 : parseInt(pageSize, 10);
        const totalPages = pageSize === "All" ? 1 : Math.ceil(filteredSubjects.length / pageSizeNum) || 1;
        let activePage = currentPage;
        if (activePage > totalPages) activePage = totalPages;
        if (activePage < 1) activePage = 1;
        const startIndex = pageSize === "All" ? 0 : (activePage - 1) * pageSizeNum;
        const paginatedSubjects = filteredSubjects.slice(startIndex, startIndex + pageSizeNum);

        const showingStart = filteredSubjects.length === 0 ? 0 : startIndex + 1;
        const showingEnd = Math.min(startIndex + pageSizeNum, filteredSubjects.length);

        // Stable class number across pages (distinct classes in sorted order) — used for the
        // "#" cell of each grouped class block.
        const classOrder = [];
        filteredSubjects.forEach((r) => {
            if (!classOrder.includes(String(r.class_id))) classOrder.push(String(r.class_id));
        });
        const classNo = (cid) => classOrder.indexOf(String(cid)) + 1;

        // Group the CURRENT page's rows by class so the class cell can rowSpan its streams.
        // Rows are sorted by class_id, so same-class rows are consecutive within the slice.
        const groupedRows = [];
        for (let i = 0; i < paginatedSubjects.length;) {
            const classId = String(paginatedSubjects[i].class_id);
            let span = 1;
            while (i + span < paginatedSubjects.length && String(paginatedSubjects[i + span].class_id) === classId) span++;
            for (let j = 0; j < span; j++) {
                groupedRows.push({ row: paginatedSubjects[i + j], isHead: j === 0, span });
            }
            i += span;
        }
        const groupCell = { ...S.td, verticalAlign: "middle", background: "#fbfcff", borderRight: "1px solid " + T.line };
        const streamCell = { ...S.td, verticalAlign: "top", borderRight: "1px solid " + T.lineSoft };

        // Visible page numbers
        const pageNumbers = [];
        const maxVisible = 5;
        let startPage = Math.max(1, activePage - Math.floor(maxVisible / 2));
        let endPage = Math.min(totalPages, startPage + maxVisible - 1);
        if (endPage - startPage + 1 < maxVisible) startPage = Math.max(1, endPage - maxVisible + 1);
        for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

        return (
            <div>
                <div style={S.tableScroll}>
                    <table style={S.table}>
                        <thead>
                            <tr>
                                <th style={{ ...S.th, width: 60 }}>#</th>
                                <th style={S.th}>Academic Year</th>
                                <th style={S.th}>Exam Standard</th>
                                <th style={S.th}>Class</th>
                                <th style={S.th}>Stream</th>
                                <th style={{ ...S.th, ...S.thSubjects }}>Subjects</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredSubjects.length === 0 ? (
                                <tr>
                                    <td colSpan={6} style={{ ...S.td, textAlign: "center", padding: "32px 16px", color: "#9ca3af", fontWeight: 600 }}>
                                        No results matching "{searchQuery}"
                                    </td>
                                </tr>
                            ) : (
                                groupedRows.map(({ row, isHead, span }) => {
                                    const rowKey = this.getRowKey(row);
                                    const rowError = rowErrors[rowKey];
                                    return (
                                        <tr
                                            key={rowKey}
                                            className="csm-row"
                                            style={{ background: rowError ? T.dangerSoft : "transparent" }}
                                        >
                                            {/* Identity cells render once per class group and span its stream rows */}
                                            {isHead && (
                                                <>
                                                    <td style={groupCell} rowSpan={span}><span style={S.sno}>{classNo(row.class_id)}</span></td>
                                                    <td style={groupCell} rowSpan={span}>{yearLabel}</td>
                                                    <td style={groupCell} rowSpan={span}>{examLabel}</td>
                                                    <td style={groupCell} rowSpan={span}><span style={S.classPill}>{row.class_name}</span></td>
                                                </>
                                            )}
                                            <td style={streamCell}>{this.renderStreamCell(row)}</td>
                                            <td style={{ ...S.td, ...S.thSubjects }}>{this.renderSubjectsCell(row)}</td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div style={S.pagination}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <select
                            style={S.pageSizeSelect}
                            value={pageSize}
                            onChange={(e) => {
                                const val = e.target.value;
                                this.setState({ pageSize: val === "All" ? "All" : parseInt(val, 10), currentPage: 1 });
                            }}
                        >
                            <option value={10}>10 / page</option>
                            <option value={25}>25 / page</option>
                            <option value={50}>50 / page</option>
                            <option value="All">All</option>
                        </select>
                        <div style={S.pageInfo}>
                            Showing {showingStart}–{showingEnd} of {filteredSubjects.length}
                        </div>
                    </div>

                    <div style={S.pageBtns}>
                        <button
                            type="button"
                            style={{ ...S.pageBtn, ...(activePage === 1 ? S.pageBtnDisabled : {}) }}
                            disabled={activePage === 1}
                            onClick={() => this.setState({ currentPage: activePage - 1 })}
                        >
                            <i className="fa fa-chevron-left" style={{ fontSize: 11 }} />
                        </button>

                        {startPage > 1 && (
                            <>
                                <button type="button" style={S.pageBtn} onClick={() => this.setState({ currentPage: 1 })}>1</button>
                                {startPage > 2 && <span style={{ color: "#9ca3af", padding: "0 2px" }}>…</span>}
                            </>
                        )}

                        {pageNumbers.map((page) => (
                            <button
                                key={page}
                                type="button"
                                style={{ ...S.pageBtn, ...(activePage === page ? S.pageBtnActive : {}) }}
                                onClick={() => this.setState({ currentPage: page })}
                            >
                                {page}
                            </button>
                        ))}

                        {endPage < totalPages && (
                            <>
                                {endPage < totalPages - 1 && <span style={{ color: "#9ca3af", padding: "0 2px" }}>…</span>}
                                <button type="button" style={S.pageBtn} onClick={() => this.setState({ currentPage: totalPages })}>{totalPages}</button>
                            </>
                        )}

                        <button
                            type="button"
                            style={{ ...S.pageBtn, ...(activePage === totalPages ? S.pageBtnDisabled : {}) }}
                            disabled={activePage === totalPages}
                            onClick={() => this.setState({ currentPage: activePage + 1 })}
                        >
                            <i className="fa fa-chevron-right" style={{ fontSize: 11 }} />
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    getFilteredClasses = () => {
        const { getBranchesQuery, getClasses } = this.props;
        const selectedBranch = Cookies.get("branch_id");
        if (!selectedBranch) return [];
        const branches = getBranchesQuery || [];
        const branch = branches.find((b) => String(selectedBranch).includes(String(b.id)));
        if (!branch) return [];
        const classIds = [...new Set(branch.sections.map((s) => s.class_id))];
        return (getClasses || []).filter((c) => classIds.includes(c.id));
    };

    getClassOptions = () =>
        this.sortClassesByName(
            (this.getFilteredClasses() || []).map((c) => ({ label: c.class, value: c.id }))
        );

    render() {
        const {
            selectedAcademicYear,
            selectedExamBoard,
            selectedClasses,
            isSubmitting,
            classSubjects,
            loader,
        } = this.state;

        const yearOptions = (this.props.getYears || []).map((year) => ({ value: year.id, label: year.academic_year, id: year.id }));
        const examOptions = (this.props.getExamBoards || []).map((board) => ({ value: board.board_id, label: board.exam_board_name, id: board.board_id }));
        const streamOptions = this.getStreamOptions();
        const showStream = streamOptions.length > 0;
        const showSaveButton = selectedClasses.length > 0 && !loader && classSubjects.length > 0;

        const multiStrings = (kind) => ({
            selectSomeItems: `Select ${kind}...`,
            allItemsAreSelected: `All ${kind} Selected`,
            selectAll: `Select All ${kind}`,
            search: "Search...",
        });

        return (
            <div style={S.page}>
                {/* Interaction styles that inline CSS can't express */}
                <style>{`
                    @keyframes csmShimmer { 0% { background-position: -800px 0; } 100% { background-position: 800px 0; } }
                    .csm-shimmer {
                        height: 44px; margin-bottom: 12px; border-radius: 10px;
                        background: #eef1f6;
                        background-image: linear-gradient(90deg, #eef1f6 0%, #e2e6ee 40%, #eef1f6 80%);
                        background-size: 800px 100%;
                        animation: csmShimmer 1.4s infinite linear;
                    }
                    .csm-row { transition: background .15s ease; }
                    .csm-row:hover { background: #f8faff !important; }
                    .csm-chip {
                        display: inline-flex; align-items: center; gap: 6px;
                        padding: 6px 13px; border-radius: 999px; cursor: pointer;
                        font-size: 12.5px; font-weight: 600; line-height: 1;
                        border: 1.5px solid ${T.line}; background: #fff; color: ${T.textMuted};
                        transition: all .14s ease;
                    }
                    .csm-chip:hover { border-color: ${T.primaryBorder}; color: ${T.primaryDark}; background: ${T.primarySoft}; }
                    .csm-chip.sel {
                        background: linear-gradient(120deg, ${T.primary} 0%, #8b5cf6 100%);
                        border-color: transparent; color: #fff;
                        box-shadow: 0 4px 10px -4px rgba(99,102,241,0.6);
                    }
                    .csm-chip.sel:hover { color: #fff; }
                    .csm-search:focus { border-color: ${T.primary} !important; background: #fff !important; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); }
                    .csm-btn-save:hover { filter: brightness(1.04); }
                    @media (max-width: 640px) {
                        .csm-page { padding: 14px !important; }
                    }
                `}</style>

                {/* Header */}
                <div style={S.filterCard}>
                    {/* <div style={S.headerBar}>
                        <div style={S.headerIcon}><i className="fa fa-book" /></div>
                        <div>
                            <h5 style={S.headerTitle}>Class Subject Mapping</h5>
                            <div style={S.headerSub}>Map subjects to each class &amp; stream for the selected academic year and exam standard.</div>
                        </div>
                    </div> */}

                    {/* Filters */}
                    <div style={S.sectionLabel}>
                        <i className="fa fa-sliders" style={{ color: T.primary }} /> Filters
                    </div>
                    <div style={S.filterGrid}>
                        <div style={S.field}>
                            <label style={S.label}><i className="fa fa-calendar" style={S.labelIcon} /> Academic Year</label>
                            <SelectDropDown
                                name="selectedAcademicYear"
                                placeholderName="Select Academic Year"
                                options={yearOptions}
                                stateData={yearOptions.find((opt) => String(opt.value) === String(selectedAcademicYear)) || null}
                                handleChange={this.handleSelectChange}
                                isClearable={false}
                            />
                        </div>

                        <div style={S.field}>
                            <label style={S.label}><i className="fa fa-graduation-cap" style={S.labelIcon} /> Exam Standard</label>
                            <SelectDropDown
                                name="selectedExamBoard"
                                placeholderName="Select exam standard"
                                options={examOptions}
                                stateData={examOptions.find((opt) => String(opt.value) === String(selectedExamBoard)) || null}
                                handleChange={this.handleSelectChange}
                                isDisabled={!selectedAcademicYear}
                            />
                        </div>

                        <div style={S.field}>
                            <label style={S.label}><i className="fa fa-university" style={S.labelIcon} /> Class</label>
                            <MultiSelect
                                options={this.getClassOptions()}
                                value={selectedClasses}
                                onChange={this.handleClassChange}
                                labelledBy="Select Classes"
                                disabled={!selectedAcademicYear}
                                overrideStrings={multiStrings("Classes")}
                            />
                        </div>

                        {/* Stream — shown ONLY for classes that carry streams (11 & 12) */}
                        {showStream && (
                            <div style={S.field}>
                                <label style={S.label}><i className="fa fa-sitemap" style={S.labelIcon} /> Stream</label>
                                <MultiSelect
                                    options={streamOptions}
                                    value={this.state.selectedStreams}
                                    onChange={this.handleStreamChange}
                                    labelledBy="Select Streams"
                                    overrideStrings={multiStrings("Streams")}
                                />
                                <span style={S.streamHint}>
                                    <i className="fa fa-info-circle" /> Pick a stream to load its subjects.
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Data grid */}
                {selectedClasses.length > 0 && (
                    <div style={S.card}>
                        <div style={S.gridHeaderRow}>
                            <div style={S.gridTitle}>
                                <div style={S.gridTitleIcon}><i className="fa fa-table" /></div>
                                <div>
                                    <div style={S.gridTitleText}>Subject Grid</div>
                                    <div style={S.gridTitleSub}>{new Set(classSubjects.map((r) => String(r.class_id))).size} class{new Set(classSubjects.map((r) => String(r.class_id))).size === 1 ? "" : "es"} · {classSubjects.length} stream row{classSubjects.length === 1 ? "" : "s"} · toggle chips to map subjects</div>
                                </div>
                            </div>

                            <div style={S.searchWrap}>
                                <i className="fa fa-search" style={S.searchIcon} />
                                <input
                                    type="text"
                                    className="csm-search"
                                    style={S.searchInput}
                                    placeholder="Search class, stream or subject…"
                                    value={this.state.searchQuery}
                                    onChange={(e) => this.setState({ searchQuery: e.target.value, currentPage: 1 })}
                                />
                                {this.state.searchQuery && (
                                    <button type="button" style={S.clearSearch} onClick={() => this.setState({ searchQuery: "", currentPage: 1 })}>
                                        <i className="fa fa-times" />
                                    </button>
                                )}
                            </div>
                        </div>

                        {this.renderTable()}
                    </div>
                )}

                {/* Save */}
                {showSaveButton && (
                    <div style={S.saveBar}>
                        <button
                            type="button"
                            className="csm-btn-save"
                            style={{ ...S.btnSave, opacity: isSubmitting ? 0.7 : 1, cursor: isSubmitting ? "not-allowed" : "pointer" }}
                            onClick={this.handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <><Spinner animation="border" size="sm" /> Saving…</>
                            ) : (
                                <><i className="fa fa-check" /> Save Configuration</>
                            )}
                        </button>
                    </div>
                )}

                <ToastContainer position="top-right" autoClose={3000} hideProgressBar newestOnTop />
            </div>
        );
    }
}

/* Avoid invalid DOM tag — use span wrapper */
const motionless = ({ style, children, ...rest }) => (
    <span style={{ display: "block", ...style }} {...rest}>
        {children}
    </span>
);

export default withRouter(
    withApollo(
        compose(
            graphql(ADD_CLASS_SUBJECTS, { name: "addClassSubjects" })
        )(CreateClassSubjects)
    )
);
